import { getDataAutomationId, getDataLinkAttributes } from "@/helpers";
import { FC } from "react";
import { Card, Media } from "@/types/General";
import Link from "@/components/Link";
import Image from "next/image";

type NewsroomCardProps = {
  type?: string;
  media?: Media;
} & Extract<Card, { type: "Newsroom" }>;

const formatDate = (date: string | null) => {
  if (!date) {
    return "";
  }
  const cardDate = new Date(date);

  // index pages are not translated yet, therefore using en-US formatting for now
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(cardDate);
};

export const NewsroomCard: FC<NewsroomCardProps> = (props) => {
  const imageProps =
    props.newsroomType === "News"
      ? {
          width: 352,
          height: 64,
          className: "aspect-11/2 object-contain",
        }
      : {
          width: 927,
          height: 619,
          className: "aspect-3/2 object-contain",
        };

  return (
    <Link
      data-automation-group="card"
      className="hover:shadow-card bg-background-highlight group focus-visible:outline-swdc-blue-400 flex flex-col gap-y-6 p-6 outline-2 outline-offset-0 outline-transparent"
      href={props.link?.url || "#"}
      {...getDataLinkAttributes(props.link)}
    >
      {props.media?.type === "image" && props.media.image && (
        <Image
          src={props.media.image}
          alt={`${props.title} Card Image`}
          loader={({ src }) => src}
          {...imageProps}
        />
      )}
      <div className="flex flex-col gap-y-2">
        <div
          className="text-body-2xs text-headline-eyebrow font-bold uppercase"
          {...getDataAutomationId("card-date")}
        >
          {formatDate(props.date)}
        </div>
        <div
          role="heading"
          aria-level={4}
          aria-label={`${props.type}: ${props.title}`}
          className="text-subhead-2xs sm:text-subhead-xs text-tab-link group-active:text-tab-link-pressed leading-7 font-bold group-hover:underline group-focus-visible:underline"
          {...getDataAutomationId("card-title")}
        >
          {props.title}
        </div>
      </div>
    </Link>
  );
};
